import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";

const el = document
	.querySelector("aurora-mobility-recommendations-podlet-isolated")!
	.shadowRoot!.querySelector("#aurora-mobility-recommendations-podlet-content")!;

const root = createRoot(el);

root.render(<App />);
